export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_07.1c0f9098.JPG";